import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export function useFeatureFlag(orgId: string | undefined, flagKey: string) {
  const { data: enabled = false } = useQuery({
    queryKey: ["feature-flag", orgId, flagKey],
    enabled: !!orgId,
    staleTime: 2 * 60 * 1000, // Cache for 2 minutes
    queryFn: async () => {
      const { data } = await supabase.rpc("read_flag_v2", {
        p_flag_key: flagKey,
        p_org_id: orgId!,
      });
      return data as boolean ?? false;
    },
  });
  return enabled;
}
